import React, { useContext, useEffect, useState } from 'react';

import { Feature } from 'config/features';
import { ContactActionContext } from 'context/ContactContext';

import { useFeature } from 'hooks/useFeature';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import { getCheck24Wireframe } from 'utility/Provide/Namespace/getCheck24Namespace';

import { ChattyClientDetailOfferParams } from 'types/chatty/offerParams';
import { ChattyData } from 'types/legacy/wireframe';

import { getChatBotConfig, getServiceCode } from './__helper/getChatBotConfig';
import { useInitChatty } from './__hooks/useInitChatty';
import FallBackUrl from './__partials/FallBackUrl';

interface ContactProps {
    offerData?: ChattyClientDetailOfferParams;
}

const Contact = ({ offerData }: ContactProps) => {
    const isChattyActive = useFeature(Feature.Chatty);
    const { _env, react, components } = useContext(CommunicationContext);
    const { setContactData } = useContext(ContactActionContext);
    const backendInformationFunc = components.backendInformationFunc;
    const isForeignDomain = _env.foreignDomain;
    const serviceCode = getServiceCode();
    const [isInitialized, setIsInitialized] = useState(false);
    const isChatActive = isChattyActive && !isForeignDomain;

    useEffect(() => {
        const getdata = () => {
            if (isChatActive) {
                if (!isInitialized) {
                    const c24Wireframe = getCheck24Wireframe();
                    const chattyData: ChattyData =
                        backendInformationFunc.getData<ChattyData>('chatty');
                    const chatbotconfig = chattyData?.config || {};
                    const mainConfig = getChatBotConfig(
                        chatbotconfig,
                        serviceCode,
                        offerData
                    );
                    setContactData({
                        chattyConfig: mainConfig,
                        check24Wireframe: c24Wireframe,
                    });
                    if (c24Wireframe) {
                        setIsInitialized(true);
                    }
                }
            }
        };

        react.bind('initChattyReact', getdata);

        return () => {
            react.unbind('initChattyReact', getdata);
        };
    }, [
        react,
        isChatActive,
        isInitialized,
        backendInformationFunc,
        _env,
        serviceCode,
        offerData,
        setContactData,
    ]);

    const { initChatty } = useInitChatty(offerData);
    if (isChatActive && isInitialized) {
        initChatty();
    } else {
        return <FallBackUrl />;
    }

    return null;
};

export default Contact;
